import { SITE_CONFIG, SUPPORT_MAILTO } from "./site";

/** Public contact shown across the site. */
export const SUPPORT_EMAIL = SITE_CONFIG.supportEmail;
export { SUPPORT_MAILTO };
